/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DrugbankExactIngredient
 */
export interface DrugbankExactIngredient {
    /**
     * 
     * @type {string}
     * @memberof DrugbankExactIngredient
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof DrugbankExactIngredient
     */
    drugbank_id?: string;
}

/**
 * Check if a given object implements the DrugbankExactIngredient interface.
 */
export function instanceOfDrugbankExactIngredient(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DrugbankExactIngredientFromJSON(json: any): DrugbankExactIngredient {
    return DrugbankExactIngredientFromJSONTyped(json, false);
}

export function DrugbankExactIngredientFromJSONTyped(json: any, ignoreDiscriminator: boolean): DrugbankExactIngredient {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'drugbank_id': !exists(json, 'drugbank_id') ? undefined : json['drugbank_id'],
    };
}

export function DrugbankExactIngredientToJSON(value?: DrugbankExactIngredient | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'drugbank_id': value.drugbank_id,
    };
}

